import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact'

const ComunicadosPublicadosExternos = (props) => {

	const [comunicados, setComunicados] = useState([]);
	const [loading, setLoading] = useState(true);

	const BotonVer = ({dato}) => (
		<span 
			onClick={() => props.history.push('/comunicado/' + dato.ID)}
			style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
		>
			<i className="fa fa-eye" style={{ marginRight: '5px' }}></i> 
		</span>
	);

	useEffect(() => {
		fetch('/z_comunicados')
		.then((res) => res.json())
		.then((res) => {
			console.log(res);
			if(res.status === 1){
				setComunicados(res.result)
			}else{
				console.log('ERROR')
			}
		})
		.catch((err) => {
			console.log('ERROR: '+err)
		})
		.finally(() => {
			setLoading(false)
		})
	}, []);

	const cabecera = [
        { Header: <b>Título</b>, accessor: 'TITULO', style: { textAlign: 'left'}, width:'auto', editable:false , show:true},
        { Header: <b>Descripción</b>, accessor: 'DESCRIPCION', style: { textAlign: 'left'}, width:'auto', editable:false , show:true},
        { Header: <b>Fecha</b>, accessor: 'FECHA_INFORMATIVA', style: { textAlign: 'center'}, width:'150', editable:false , show:true}
    ];

	return (
	<Fragment>
		<Breadcrumb parent="Comunicados" title="Publicados Externos"/>
		<div className="card">
			<div className="container-fluid">
			{
				loading ?
				<div className="d-flex justify-content-center align-items-center">
					<div className="loader-box mr-4">
						<div className="loader">
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
						</div>
					</div>
					<h5 className="text-uppercase">Cargando...</h5>
				</div>
				:
				<div className="row">
					<div className="col-sm-12 mt-3">
						<Tablereact
                            myData={comunicados}
                            cabecera={cabecera}
                            pageSize={10}
                            paginacion={true}
                            buscador='Buscar Comunicado Externo'
                            componente={{nombre: 'Acciones', Component: BotonVer}}
                        />
					</div>
				</div>
			}
			</div>
		</div>
	</Fragment>
	);
}
 
export default ComunicadosPublicadosExternos;
